import "./HeroImg3Styles.css";

import React from 'react';


const HeroImg3 = () => {
  return (
    <div className="hero-img2">
        <div className="heading">
            <h1>Get in Touch</h1>
            <p>Contact me</p>
        </div>
    </div>
  );
};

export default HeroImg3